import clsx from "clsx";
import React, { forwardRef, ReactNode } from "react";

import { Container } from "../../container";

export interface JobsGridLayoutProps {
  labels: Record<string, string | null>;
  positionsField: ReactNode;
  locationsField: ReactNode;
  macrofunctionsField: ReactNode;
  formCancelButton: ReactNode;
  formSubmitButton: ReactNode;
  jobsCount: ReactNode;
  jobs: ReactNode;
  error: ReactNode;
  pagination?: ReactNode;
}

export const JobsGridLayout = forwardRef<HTMLDivElement, JobsGridLayoutProps>(
  (
    {
      labels,
      positionsField,
      locationsField,
      macrofunctionsField,
      formCancelButton,
      formSubmitButton,
      jobsCount,
      jobs,
      error,
      pagination,
    },
    ref
  ) => {
    return (
      <Container
        ref={ref}
        className="pb-16 bg-neutral"
        containerClassName="flex flex-col gap-8"
        pagePaddingX
      >
        <div className="bg-light rounded-3xl p-5 lg:p-8 flex flex-col gap-4">
          <h2 className="text-2xl lg:text-3xl text-primary">{labels["jobs-search-title"]}</h2>
          <div className="grid grid-cols-6 gap-2 lg:gap-y-4 lg:gap-x-6 items-baseline">
            <div className="col-span-6 md:col-span-6 lg:col-span-2">{positionsField}</div>
            <div className="col-span-6 md:col-span-3 lg:col-span-2">{locationsField} </div>
            <div className="col-span-6 md:col-span-3 lg:col-span-2">{macrofunctionsField} </div>
          </div>
          <div className="flex items-center gap-4 mt-2">
            {formCancelButton}
            {formSubmitButton}
          </div>
        </div>

        {error ? (
          <div className="text-center w-full text-xl">{error}</div>
        ) : (
          <>
            <div className="text-center mx-auto font-semibold text-xl">{jobsCount}</div>

            <div
              className={clsx(
                "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4",
                "gap-5 lg:gap-x-8 lg:gap-y-16"
              )}
            >
              {jobs}
            </div>
            {pagination && <div className="flex justify-center w-full">{pagination}</div>}
          </>
        )}
      </Container>
    );
  }
);
